import AppAdvancedSetting from '$pages/Apps/AppAdvancedSetting'
import AppBasicSetting from '$pages/Apps/AppBasicSetting'
import AppGroupCreate from '$pages/Apps/AppGroup/Create'
import AppGroupDetail from '$pages/Apps/AppGroup/Detail'
import AppGroupEdit from '$pages/Apps/AppGroup/Edit'
import AppGroupList from '$pages/Apps/AppGroup/List'
import AppHome from '$pages/Apps/AppHome'
import AppLaunchPadSetting from '$pages/Apps/AppLaunchPadSetting'
import AppPermissionDetail from '$pages/Apps/AppPermission/Detail'
import AppPermissionList from '$pages/Apps/AppPermission/List'
import AppRoleDetail from '$pages/Apps/AppRole/Detail'
import AppRoleList from '$pages/Apps/AppRole/List'
import AppList from '$pages/Apps/List'
import { ROUTE_NAMES } from '$router/config'
import AppWebhooks from '$pages/Apps/AppWebhooks'
import AppUserList from '$pages/Apps/AppUser/List'
import AppUserDetail from '$pages/Apps/AppUser/Detail'

export const APPLICATION_ROUTES: {
  name: ROUTE_NAMES
  Component: JSX.Element
  withSidebar?: boolean
}[] = [
  {
    name: ROUTE_NAMES.APPS,
    Component: <AppList />
  },
  {
    name: ROUTE_NAMES.APP_HOME,
    Component: <AppHome />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_BASIC_SETTING,
    Component: <AppBasicSetting />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_ADVANCED_SETTING,
    Component: <AppAdvancedSetting />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_WEBHOOK_SETTING,
    Component: <AppWebhooks />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_LAUNCHPAD_SETTING,
    Component: <AppLaunchPadSetting />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_GROUPS,
    Component: <AppGroupList />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_GROUP_DETAIL,
    Component: <AppGroupDetail />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_GROUP_CREATE,
    Component: <AppGroupCreate />
  },
  {
    name: ROUTE_NAMES.APP_GROUP_EDIT,
    Component: <AppGroupEdit />
  },
  {
    name: ROUTE_NAMES.APP_ROLES,
    Component: <AppRoleList />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_ROLE_DETAIL,
    Component: <AppRoleDetail />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_USERS,
    Component: <AppUserList />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_USER_DETAIL,
    Component: <AppUserDetail />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_PERMISSIONS,
    Component: <AppPermissionList />,
    withSidebar: true
  },
  {
    name: ROUTE_NAMES.APP_PERMISSION_DETAIL,
    Component: <AppPermissionDetail />,
    withSidebar: true
  }
]
